import * as React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { Icon, Card, IconButton, Form, Notification } from '../';
import StaggeredList from '../StaggeredList/StaggeredList';
import { getPostcode } from '../../redux/actions/postcodes';

interface Address {
  address: string;
  address_2: string;
  city: string;
  county: string;
}

interface Props {
  postcode?: string;
  address?: Address;
  handleUpdate: Function;
  dispatch: Function;
  errors?: string[];
}

interface State {
  postcode: string;
  address: Address;
  addresses: Array<any>;
  isDirty: boolean;
  errorMessage: string | boolean;
  setAddress: Function;
}

class AddressPicker extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      postcode: this.props.postcode,
      address: this.props.address,
      addresses: [],
      isDirty: false,
      errorMessage: false,
      setAddress: () => {},
    };
  }

  render() {
    return (
      <div className="address-picker">
        <div className="field" />
        <Form
          fields={[{ name: 'postcode', label: 'Postcode*', type: 'text' }]}
          type="postcode"
          hasButton={false}
          errors={this.props.errors ? this.props.errors : []}
          handleChange={({ postcode }) => {
            this.props.handleUpdate(postcode, this.state.address);
            this.setState({ postcode, isDirty: true, errorMessage: false });
          }}
          getDispatch={(dispatch) => {
            dispatch(
              actions.change('postcode.postcode', this.props.postcode || ''),
            );
          }}
        />
        <div className="field" />
        <div className="field is-clearfix">
          <IconButton
            icon="location-arrow"
            className="is-default is-pulled-right"
            handleClick={async () => {
              const { data, error } = await this.props.dispatch(
                getPostcode(this.state.postcode),
              );
              if (error) {
                this.setState({ errorMessage: error });
                return;
              }
              this.setState({
                isDirty: false,
                addresses: data,
                errorMessage: false,
              });
            }}
          >
            Lookup Address
          </IconButton>
        </div>
        {!this.state.isDirty &&
          this.state.addresses.length > 0 && (
            <div className="field">
              <StaggeredList>
                {this.state.addresses.map((address, index) => (
                  <Card
                    key={index}
                    list
                    handleClick={() => {
                      this.setState({ isDirty: true }, () => {
                        this.state.setAddress(address);
                        this.props.handleUpdate(this.state.postcode, address);
                      });
                    }}
                  >
                    <Icon icon="home" />{' '}
                    {Object.values(address)
                      .filter((line: string) => line.replace(' ', '').length)
                      .join(', ')}
                  </Card>
                ))}
              </StaggeredList>
            </div>
          )}
        {this.state.errorMessage !== false && (
          <Notification type="danger">{this.state.errorMessage}</Notification>
        )}
        <Form
          fields={[
            { name: 'address', label: 'Address 1*', type: 'text' },
            { name: 'address_2', label: 'Address 2', type: 'text' },
            { name: 'city', label: 'City', type: 'text' },
            { name: 'county', label: 'County', type: 'text' },
          ]}
          type="address"
          errors={this.props.errors ? this.props.errors : []}
          hasButton={false}
          handleChange={({ address, address_2, city, county }) => {
            this.props.handleUpdate(this.state.postcode, {
              address,
              address_2,
              city,
              county,
            });
            this.setState({ address });
          }}
          getDispatch={(dispatch) => {
            this.setState(
              {
                setAddress: (value) => {
                  ['address', 'address_2', 'city', 'county'].map((field) =>
                    dispatch(
                      actions.change(`address.${field}`, value[field] || ''),
                    ),
                  );
                },
              },
              () => {
                this.state.setAddress(
                  this.props.address || {
                    address: '',
                    address_2: '',
                    city: '',
                    county: '',
                  },
                );
              },
            );
          }}
        />
      </div>
    );
  }
}

export default connect()(AddressPicker);
